import {IState} from './Types';

/**
 *
 */
export const parser = {
  /**
   *
   * @param payload
   */
  sigin: (payload: any) => {
    if (payload) {
      const {id, token, begin, lifetime} = payload.credentials;
      const {email} = payload.info;
      const {
        entities,
        banks,
        profile,
        faq,
        phone,
        uiConfiguration,
        whatsApp,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
      } = payload;

      return {
        id,
        email,
        session: {
          begin,
          lifetime,
          token,
        },
        entities,
        banks,
        profile,
        faq,
        whatsApp,
        phone,
        uiConfiguration,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
      } as unknown as IState;
    }
  },

  processResources: (state: IState, payload: any) => {
    if (payload) {
      const {
        salesTerritories,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
        salesCategories,
        salesCities,
      } = payload;

      return {
        ...state,
        clientTerritories: salesTerritories,
        customerTypes,
        customerRequiredDocumentList,
        customerRequiredDocumentsHelp,
        customerPaymentOptions,
        clientCategories: salesCategories,
        clientCities: salesCities,
      } as IState;
    }
  },

  balanceSheetSalesman: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceSheet: payload,
    } as IState;
  },
  salesmanClientList: (state: IState, payload: any): IState => {
    return {
      ...state,
      clients: payload ?? [],
    } as IState;
  },
  salesmanProductList: (state: IState, payload: any): IState => {
    return {
      ...state,
      clientProductList: payload ?? [],
    } as IState;
  },
  setSalesmanProductToAdd: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanProductToAdd: payload,
    } as IState;
  },
  updateSalesmanNewOrder: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanNewOrder: payload,
    } as IState;
  },
  updateCandidateToShoppingCart: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanOrderItemCandidate: payload,
    } as IState;
  },
  setSalesmanClient: (state: IState, payload: any): IState => {
    return {
      ...state,
      client: payload,
    } as IState;
  },
  sendSalesmanNewOrder: (state: IState): IState => {
    return {
      ...state,
      salesmanNewOrder: null,
      salesmanProductToAdd: null,
      salesmanOrderItemCandidate: null,
    } as IState;
  },
  fetchBalanceCustomer: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceCustomer: payload,
    } as IState;
  },
  setNewSalesmanClientRequest: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanNewClientRequest: payload ?? [],
    } as IState;
  },
  proccessNewClientRequest: (state: IState): IState => {
    return {
      ...state,
      salesmanNewClientRequest: null,
    } as IState;
  },
  setClientHistory: (state: IState, payload: any): IState => {
    return {
      ...state,
      history: payload ?? [],
    } as IState;
  },
  balanceList: (state: IState, payload: any): IState => {
    return {
      ...state,
      balances: payload ?? [],
    } as IState;
  },
  semaphoreItems: (state: IState, payload: any): IState => {
    return {
      ...state,
      semaphoreItems: payload ?? [],
    } as IState;
  },
  debtorList: (state: IState, payload: any): IState => {
    return {
      ...state,
      debtors: payload ?? [],
    } as IState;
  },

  setPortfolioFilter: (state: IState, payload: any): IState => {
    return {
      ...state,
      clientPortfolioFilter: payload,
    } as IState;
  },
  setFilterTracking: (state: IState, payload: any): IState => {
    return {
      ...state,
      filterTracking: payload,
    } as IState;
  },
};
